import React from "react";
import { useParams, Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { ArrowLeft, User, Calendar } from "lucide-react";

export default function BlogDetail() {
  const { slug } = useParams();
  const { lang, t } = useLang();
  const [post, setPost] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="pt-32 pb-32 container-x text-muted-foreground">Loading…</div>;
  if (!post) return (
    <div className="pt-32 pb-32 container-x">
      <p className="text-muted-foreground">Post not found.</p>
      <Link to="/blog" className="btn-outline mt-6">{t("common.backToBlog")}</Link>
    </div>
  );

  const title = lang === "id" ? post.title_id : post.title_en;
  const content = lang === "id" ? post.content_id : post.content_en;

  return (
    <article data-testid="blog-detail-page" className="pt-32 lg:pt-40 pb-32">
      <SEO
        title={post.title_id}
        titleEn={post.title_en}
        description={post.excerpt_id}
        descriptionEn={post.excerpt_en}
        image={post.cover}
        type="article"
      />
      <div className="container-x max-w-3xl">
        <Link to="/blog" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary text-sm mb-10" data-testid="back-to-blog">
          <ArrowLeft className="h-4 w-4" /> {t("common.backToBlog")}
        </Link>
        <p className="overline mb-5">{post.category}</p>
        <h1 className="h-display text-primary text-balance">{title}</h1>
        <div className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-sm text-muted-foreground">
          <span className="inline-flex items-center gap-1.5"><User className="h-3.5 w-3.5 text-accent" />{post.author}</span>
          <span className="inline-flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5 text-accent" />{post.published_at}</span>
        </div>
      </div>
      <div className="container-x max-w-4xl mt-12">
        <div className="aspect-[16/9] rounded-lg overflow-hidden border border-border">
          <img src={post.cover} alt="" className="w-full h-full object-cover" />
        </div>
      </div>
      <div className="container-x max-w-3xl mt-12">
        <div className="prose prose-lg max-w-none text-foreground/85 leading-relaxed">
          {content.split("\n\n").map((para, i) => (
            <p key={i} className="mb-5 whitespace-pre-line">{para}</p>
          ))}
        </div>
      </div>
    </article>
  );
}
